<!--
 * @Author: yindengli
 * @Date: 2023-09-26 16:11:40
 * @LastEditTime: 2023-10-17 15:00:07
 * @LastEditors: yindengli
 * @Description: 
 * @FilePath: \openseeyon-index-front\src\components\login\codeVerify.vue
-->
<template>
  <div class="box-sub-title" :class="{'is-white': isWhite}">
    <div>{{ text }}</div>
    <slot></slot>
    <div class="box-sub-title-line"></div>
  </div>
</template>

<script>
export default {
  name: 'SubTitle',
  props: {
    text: String,
    isWhite: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.box-sub-title{
  font-weight: 600;
  font-size: 16px;
  color: #333;
  text-align: center;
  margin: 20px 0;

  &-line{
    margin: 0 auto;
    margin-top: 2px;
    width: 28px;
    height: 4px;
    background: #0077FF;
    border-radius: 3px;
  }
  &.is-white{
    color: #fff;

    .box-sub-title-line{
      background: #fff;
    }
  }
}
</style>